import { useEffect, useMemo, useState ,useRef} from "react";
import "./App.css";
import { getProductList } from "./api/products";
import Select  from "react-select";

const priceFormatter = new Intl.NumberFormat("en-SA", {
  style: "currency",
  currency: "SAR",
  minimumFractionDigits: 2,
});

const PLACEHOLDER_IMAGE =
  "https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?auto=format&fit=crop&w=400&q=60";

const getCategoryEmoji = (name = "") => {
  name = name.toLowerCase();

  const emojiMap = [
    { keys: ["platter", "mains"], emoji: "🍽️" },
    { keys: ["salad"], emoji: "🥗" },
    { keys: ["sandwich"], emoji: "🥪" },
    { keys: ["amuse", "bouche"], emoji: "🍢" },
    { keys: ["aperitif"], emoji: "🍸" },
    { keys: ["bakery", "pastries", "scones"], emoji: "🥐" },
    { keys: ["beer"], emoji: "🍺" },
    { keys: ["beverage", "juice"], emoji: "🧃" },
    { keys: ["breakfast"], emoji: "🍳" },
    { keys: ["cereal"], emoji: "🥣" },
    { keys: ["champagne"], emoji: "🍾" },
    { keys: ["cocktail", "mocktail"], emoji: "🍹" },
    { keys: ["coffee"], emoji: "☕" },
    { keys: ["cognac", "liqueur", "rum", "tequila", "whiskey"], emoji: "🥃" },
    { keys: ["cold"], emoji: "🧊" },
    { keys: ["dairy"], emoji: "🥛" },
    { keys: ["dessert wine"], emoji: "🍷" },
    { keys: ["dessert"], emoji: "🍰" },
    { keys: ["wine", "chardonnay","vodka"], emoji: "🍷" },
    { keys: ["fruttini"], emoji: "🍓" },
    { keys: ["hot chocolate"], emoji: "🍫" },
    { keys: ["ice crem", "ice cream"], emoji: "🍨" },
    { keys: ["savory"], emoji: "🍢" },
    { keys: ["soft drink"], emoji: "🥤" },
    { keys: ["soup"], emoji: "🥣" },
    { keys: ["sparkling water"], emoji: "💧" },
    { keys: ["still water"], emoji: "💧" },
    { keys: ["sushi"], emoji: "🍣" },
    { keys: ["tea"], emoji: "🍵" },
  ];

  for (const item of emojiMap) {
    if (item.keys.some(k => name.includes(k))) {
      return item.emoji;
    }
  }

  return "🍽️"; // default
};


const buildThumb = (img = {}) => {
  if (!img || typeof img !== "object") return PLACEHOLDER_IMAGE;

  if (img.thumbnailURL?.startsWith("http")) return img.thumbnailURL;

  if (img.thumbnailURL)
   // return `${process.env.REACT_APP_API_BASE_URL}${img.thumbnailURL}`;
    return `${window.APP_CONFIG.BASE_URL}${img.thumbnailURL}`;

  if (img.imageURL?.startsWith("http")) return img.imageURL;

  if (img.imageURL)
   // return `${process.env.REACT_APP_API_BASE_URL}${img.imageURL}`;
    return `${window.APP_CONFIG.BASE_URL}${img.imageURL}`;

  return PLACEHOLDER_IMAGE;
};

const buildFull = (img = {}) => {
  if (!img || typeof img !== "object") return PLACEHOLDER_IMAGE;

  if (img.imageURL?.startsWith("http")) return img.imageURL;

  if (img.imageURL)
   // return `${process.env.REACT_APP_API_BASE_URL}${img.imageURL}`;
    return `${window.APP_CONFIG.BASE_URL}${img.imageURL}`;

  return PLACEHOLDER_IMAGE;
};

const resolvePrice = (product) => {
  // const sectionPrice = product.sectionWiseProductDetailList?.find(
  //   (d) => d.isActive && d.price > 0
  // )?.price;

  return  product.basePrice || product.cost || 0;
};

const buildImageUrl = (images = []) => {
  if (!images.length) return PLACEHOLDER_IMAGE;

  const main =
    images.find((i) => i.thumbnailURL) ||
    images.find((i) => i.imageURL) ||
    null;

  if (!main) return PLACEHOLDER_IMAGE;

  const path = main.thumbnailURL || main.imageURL;

  if (path.startsWith("http")) return path;
 // return `${process.env.REACT_APP_API_BASE_URL}${path}`;
  return `${window.APP_CONFIG.BASE_URL}${path}`;
};

function App() {
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [activeCategory, setActiveCategory] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [activeProduct, setActiveProduct] = useState(null);
const sectionRefs = useRef({});
const categoryTabRefs = useRef({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const response = await getProductList();
        setProducts(response?.filter((i) => i.isMenuItem) || []);
      } catch (err) {
        setError("Unable to load menu.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);


  const categories = useMemo(() => {
    const set = new Set();
    products.forEach((p) => set.add(p.category?.name || "Chef Specials"));
    return [...set];
  }, [products]);

  const categoryOptions = useMemo(() => {
  return [
    { label: "All categories", value: "all" },
    ...categories.map((c) => ({
      label: c,
      value: c,
    })),
  ];
}, [categories]);

  const filteredProducts = useMemo(() => {
    const t = searchTerm.toLowerCase().trim();

    return products.filter((p) => {
      const cat = p.category?.name || "Chef Specials";

      if (selectedCategory !== "all" && selectedCategory !== cat) return false;

      if (!t) return true;

      return (
        p.name?.toLowerCase().includes(t) ||
        p.arabicDescription?.toLowerCase().includes(t) ||
        p.otherDescription?.toLowerCase().includes(t)
      );
    });
  }, [products, selectedCategory, searchTerm]);

  const groupedProducts = useMemo(() => {
    const map = {};
    filteredProducts.forEach((p) => {
      const c = p.category?.name || "Chef Specials";
      if (!map[c]) map[c] = [];
      map[c].push(p);
    });
    return map;
  }, [filteredProducts]);

  // const categoryOrder =
  //   selectedCategory === "all" ? categories : [selectedCategory];
const categoryOrder = categories;

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveCategory(entry.target.dataset.category);
        }
      });
    },
    {
      rootMargin: "-120px 0px -80% 0px",
      threshold: 0,
    }
  );

  Object.values(sectionRefs.current).forEach((el) => {
    if (el) observer.observe(el);
  });

  return () => observer.disconnect();
}, [filteredProducts]);


      // CAROUSEL HANDLERS
  // ----------------------------------------
  const [slideIndex, setSlideIndex] = useState(0);
  const carouselRef = useRef(null);
  const touchStartX = useRef(0);

  // const nextSlide = () => {
  //   if (!activeProduct) return;
  //   setSlideIndex((i) =>
  //     i + 1 >= activeProduct.productImages.length ? 0 : i + 1
  //   );
  // };

  // const prevSlide = () => {
  //   if (!activeProduct) return;
  //   setSlideIndex((i) =>
  //     i - 1 < 0 ? activeProduct.productImages.length - 1 : i - 1
  //   );
  // };

  const nextSlide = () => {
  if (!activeProduct?.productImages?.length) return;
  if (activeProduct.productImages.length === 1) return;

  setSlideIndex((i) =>
    i + 1 >= activeProduct.productImages.length ? 0 : i + 1
  );
};

const prevSlide = () => {
  if (!activeProduct?.productImages?.length) return;
  if (activeProduct.productImages.length === 1) return;

  setSlideIndex((i) =>
    i - 1 < 0 ? activeProduct.productImages.length - 1 : i - 1
  );
};

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const diff = e.changedTouches[0].clientX - touchStartX.current;

    if (diff > 50) prevSlide();
    if (diff < -50) nextSlide();
  };

  // Reset slide when opening product
  const openProduct = (p) => {
    setActiveProduct(p);
    setSlideIndex(0);
  };

useEffect(() => {
  if (!activeCategory) return;

  const el = categoryTabRefs.current[activeCategory];
  if (!el) return;

  el.scrollIntoView({
    behavior: "smooth",
    inline: "center",
    block: "nearest",
  });
}, [activeCategory]);

const getPopupImages = (images = []) => {
  if (!Array.isArray(images)) return [];

  // Prefer real product images
  const fullImages = images.filter(
    (img) =>
      img.imageURL &&
      img.imageURL.includes("/product-images/")
  );

  // If real images exist → use them
  if (fullImages.length > 0) return fullImages;

  // Else fallback to thumbnails
  return images.filter(
    (img) =>
      img.thumbnailURL &&
      img.thumbnailURL.includes("/product-thumbs/")
  );
};


  return (
    <div className="menu-app">
      {/* ---------- HEADER ---------- */}
      <header className="hero">
        <p className="hero-subtitle">قائمة طعام مطعمك</p>
        <h1>Freej Swaeleh Menu</h1>
        <p className="hero-description">
          Taste the classics. Tap a category to explore every dish in seconds.
        </p>
      </header>

      {/* ---------- FILTERS ---------- */}
      <div className="filters">
        <div className="search-container">
          <input
            type="search"
            className="search-input"
            placeholder="Search dishes or Arabic names..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* <div className="filter-select">
          <label>Filter</label>
       <Select
       className="react-select"
  options={categoryOptions}
  value={categoryOptions.find((opt) => opt.value === selectedCategory)}
  onChange={(selected) => setSelectedCategory(selected.value)}
  
/>
        </div> */}
      </div>

      {/* ---------- CATEGORY TABS ---------- */}
      <nav className="category-tabs">
        {/* <button
          className={`category-chip ${
            selectedCategory === "all" ? "active" : ""
          }`}
          onClick={() => setSelectedCategory("all")}
        >
          All
        </button> */}
<button
  ref={(el) => (categoryTabRefs.current["all"] = el)}
  className={`category-chip ${
    selectedCategory === "all" && !activeCategory ? "active" : ""
  }`}
  onClick={() => {
    setSelectedCategory("all");
    setActiveCategory(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
>
  All
</button>



        {/* {categories.map((c) => (
          <button
            key={c}
            // className={`category-chip ${
            //   selectedCategory === c ? "active" : ""
            // }`}
            // onClick={() => setSelectedCategory(c)}
            onClick={() => {
  setSelectedCategory("all");   // keep all sections visible
  sectionRefs.current[c]?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}}
            className={`category-chip ${
  activeCategory === c || selectedCategory === c ? "active" : ""
}`}
          >
            {getCategoryEmoji(c)} {c}
          </button>
        ))} */}
        {categories.map((c) => (
  <button
    key={c}
    ref={(el) => (categoryTabRefs.current[c] = el)}
    className={`category-chip ${
      activeCategory === c ? "active" : ""
    }`}
    onClick={() => {
      setSelectedCategory("all");
      sectionRefs.current[c]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }}
  >
    {getCategoryEmoji(c)} {c}
  </button>
))}

      </nav>

      {/* ---------- MAIN CONTENT ---------- */}
      <main className="menu-content">
        {loading && <div className="state-card">Loading menu...</div>}
        {error && <div className="state-card error">{error}</div>}

        {!loading &&
          categoryOrder.map((cat) => {
            const items = groupedProducts[cat] || [];
            if (!items.length) return null;

            return (
              // <section key={cat} className="menu-section">
              <section
  key={cat}
  className="menu-section"
  data-category={cat}
  ref={(el) => (sectionRefs.current[cat] = el)}
>
                <div className="section-header">
                  <span>{getCategoryEmoji(cat)}</span>
                  <h2>{cat}</h2>
                </div>

                <div className="menu-card-stack">
                  {items.map((p) => {
                    const price = resolvePrice(p);

                    return (
                      <article
                        className="menu-card"
                        key={p.guid}
                        onClick={() => setActiveProduct(p)}
                      >
                        <img
                          src={buildImageUrl(p.productImages)}
                          className="menu-card__image"
                          alt={p.name}
                        />

                        <div className="menu-card__body">
                          <div className="menu-card__title-row">
                            <div>
                              <h3>{p.name}</h3>
                              {p.arabicDescription && (
                                <p className="arabic-name">
                                  {p.arabicDescription}
                                </p>
                              )}
                            </div>

                            <span className="price">
                              {priceFormatter.format(price)}
                            </span>
                          </div>

                        </div>
                      </article>
                    );
                  })}
                </div>
              </section>
            );
          })}
      </main>

{/* ---------- PRODUCT POPUP ---------- */}
{activeProduct && (() => {
  // const images = activeProduct?.productImages || [];
  const images = getPopupImages(activeProduct?.productImages);
  const safeIndex = Math.max(0, Math.min(slideIndex, images.length - 1));

  return (
    <div className="modal-overlay" onClick={() => setActiveProduct(null)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        
        {/* --- CAROUSEL (Safe) --- */}
        {/* {images.length > 0 && (
          <div
            className="carousel"
            ref={carouselRef}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <img
              src={buildFull(images[safeIndex])}
              className="carousel-img"
              alt=""
            />

            <button className="nav-btn left" onClick={prevSlide}>‹</button>
            <button className="nav-btn right" onClick={nextSlide}>›</button>

            <div className="dots">
              {images.map((_, i) => (
                <span
                  key={i}
                  className={i === safeIndex ? "dot active" : "dot"}
                />
              ))}
            </div>
          </div>
        )} */}
{/* --- PRODUCT IMAGE / CAROUSEL --- */}
{images.length === 1 && (
  <img
    src={buildFull(images[0])}
    className="carousel-img"
    alt={activeProduct.name}
  />
)}

{images.length > 1 && (
  <div
    className="carousel"
    ref={carouselRef}
    onTouchStart={handleTouchStart}
    onTouchEnd={handleTouchEnd}
  >
    <img
      src={buildFull(images[safeIndex])}
      className="carousel-img"
      alt={activeProduct.name}
    />

    <button className="nav-btn left" onClick={prevSlide}>‹</button>
    <button className="nav-btn right" onClick={nextSlide}>›</button>

    <div className="dots">
      {images.map((_, i) => (
        <span
          key={i}
          className={i === safeIndex ? "dot active" : "dot"}
        />
      ))}
    </div>
  </div>
)}

        {/* --- NAME --- */}
        <h2>{activeProduct.name}</h2>

        {activeProduct.arabicDescription && (
          <p className="arabic-name">{activeProduct.arabicDescription}</p>
        )}
    
      

        {/* --- HTML DESCRIPTION --- */}
        {images[safeIndex]?.imgDescription && (
          <div
            className="img-html"
            dangerouslySetInnerHTML={{
              __html: images[safeIndex].imgDescription,
            }}
          />
        )}

        {/* --- THUMBNAILS --- */}
        {/* {images.length > 0 && (
          <div className="thumb-row">
            {images.map((img, i) => (
              <img
                key={i}
                src={buildThumb(img)}
                className={
                  i === safeIndex ? "thumb-img active-thumb" : "thumb-img"
                }
                onClick={() => setSlideIndex(i)}
              />
            ))}
          </div>
        )} */}

        <button className="close-btn" onClick={() => setActiveProduct(null)}>
          Close
        </button>
      </div>
    </div>
  );
})()}

    </div>
  );
}

export default App;
